// extracted by mini-css-extract-plugin
export default {"logoWrapper":"gvFaDrtymGynggjJcJYg"};